<template>
  <div class="create-habit flex flex-col justify-between">
    <div>
      <header class="mint-header left-center-header">
        <router-link to="/habits" class="justify-self-start">
          <i class="material-icons">arrow_back_ios_new</i>
        </router-link>
        <span>Create a Habit</span>
        <div></div>
      </header>

      <template v-if="categories">
        <div class="w-full flex justify-center px-2 mt-4">
          <t-select v-model="usingExistingCategory" :options="options" />
        </div>
        <mt-field
          v-if="isCreateNewCategory"
          label="Category:"
          placeholder="e.g. Morning Ritual"
          v-model="habitCategory"
          class="w-full mt-2 category"
          :state="categoryValidation"
        ></mt-field>
        <mt-field
          v-else
          label="Category:"
          placeholder="e.g. Morning Ritual"
          v-model="usingExistingCategory"
          class="w-full mt-2 category"
          :state="categoryValidation"
        ></mt-field>
      </template>

      <mt-field
        v-else
        label="Category:"
        placeholder="e.g. Health"
        v-model="habitCategory"
        class="w-full"
        :state="categoryValidation"
      ></mt-field>

      <mt-field
        label="Name:"
        placeholder="e.g. Full body stretching"
        v-model="habitName"
        :state="nameValidation"
      ></mt-field>
      <mt-field
        label="Description:"
        placeholder="e.g. Listen to podcast"
        v-model="habitDescription"
      ></mt-field>

      <div class="flex justify-center mt-10">
        <div>
          <t-toggle v-model="habitIsPositive" class="" />
        </div>
        <span
          class="ml-3"
          :class="habitIsPositive ? 'text-success' : 'text-warning'"
          >{{ habitIsPositive ? 'Positive' : 'Negative' }} Habit!</span
        >
      </div>
    </div>

    <div class="flex justify-center p-10">
      <t-button
        @click="save"
        :variant="{
          success: isSaved,
          error:
            categoryValidation === 'warning' || nameValidation === 'warning'
        }"
      >
        {{ isSaved ? 'Saved' : 'Save' }}
      </t-button>
    </div>
  </div>
</template>

<script>
import userModule from '@/store/modules/user.module'
import categoryModule from '@/store/modules/category.module'
import habitModule from '@/store/modules/habit.module'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment/src/moment'

export default {
  name: 'CreateHabit',

  data() {
    return {
      habitName: '',
      habitIsPositive: true,
      habitDescription: '',
      habitCategory: '',
      usingExistingCategory: 'Create New Category',
      existingCategories: [],
      isSaved: false,
      nameValidation: '',
      categoryValidation: ''
    }
  },

  computed: {
    user: userModule.user,
    categories: categoryModule.categories,
    habits: habitModule.habits,

    isCreateNewCategory() {
      return this.usingExistingCategory === 'Create New Category'
    },

    options() {
      const categories = Array.from(this.categories)
      categories.unshift('Create New Category')
      return categories
    }
  },

  methods: {
    save() {
      const habitCategory = this.isCreateNewCategory
        ? this.habitCategory
        : this.usingExistingCategory
      const isNameValid = this.validateName()
      const isCategoryValid = this.validateCategory(habitCategory)
      if (!isNameValid || !isCategoryValid) return

      const habit = {
        name: this.habitName,
        description: this.habitDescription,
        category: habitCategory,
        isPositive: this.habitIsPositive,
        monthCreated: moment().month(),
        yearCreated: moment().year(),
        userId: this.user.id
      }

      this.$store.dispatch('createHabit', {
        habitId: uuidv4(),
        habit
      })

      this.categories.add(habitCategory)
      this.isSaved = true
      setTimeout(() => this.$router.push({ name: 'Habits' }), 800)
    },

    validateCategory(habitCategory) {
      const createNewCategoryEmpty =
        this.isCreateNewCategory && this.habitCategory === ''
      const usingExistingCategoryEmpty =
        !this.isCreateNewCategory && this.usingExistingCategory === ''
      if (createNewCategoryEmpty || usingExistingCategoryEmpty) {
        this.categoryValidation = 'warning'
        return false
      }

      return true
    },

    validateName() {
      if (this.habitName === '') {
        this.nameValidation = 'warning'
        return false
      }

      return true
    }
  },

  mounted() {
    this.existingCategories = Array.from(this.categories)
  }
}
</script>

<style lang="scss">
.create-habit {
  height: calc(100vh - 62px);
}
.category > div.mint-cell-wrapper {
  background: none;
}
.text-warning {
  color: rgb(255, 186, 0);
}
.text-success {
  color: #68d391;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='%23000000'><polygon points='0,0 100,0 50,50'/></svg>")
    no-repeat;
  background-size: 10px;
  background-position: right 0.5em top 60%;
  background-repeat: no-repeat;
  background-color: #ffffff;
}
</style>
